import { SectionHeading } from "@/components/landing/shared";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useSiteContent } from "@/context/ContentContext";

export default function FAQSection() {
  const { faq } = useSiteContent();
  const items = faq.items || [];
  return (
    <section
      id="faq"
      className="relative scroll-mt-20 border-t border-black/[0.08] py-16 md:py-24 lg:py-28"
    >
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-6 lg:px-8">
        <SectionHeading eyebrow={faq.eyebrow} title={faq.title} />

        <div className="mt-10" data-testid="faq-accordion">
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-black/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-[15px] font-medium text-[color:var(--text-primary)] hover:text-emerald-700 hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-secondary">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
